module.exports = __webpack_public_path__ + "img/face-doubt.90c652c0.svg";